module.exports = __webpack_public_path__ + "img/x-ray.cb2d8b17.svg";